import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import '../signupcategory/SignupCategory.css'
import useApi from '../../customHook/useApi';

const SignupCategory = () => {
  const navigate = useNavigate();
  const { data, error, loading, postFormData } = useApi('https://codezens.com/luststory/index.php/api');
  const { userId } = useSelector((state) => state.user);

  const handleUserType = async (userType) => {
    try {
      const response = await postFormData('/create_user_type', { user_id: userId, type: userType });
      if(response && response.status === 1){
        navigate('/subscription');
      }
    } catch (error) {
      toast.error('Error occurred while processing your request');
    }

  }
  return (
    <div className='login-section w-100 '>
      <Link rel='stylesheet' to="/signup" className='back-btn'>Back</Link>
      <div className='login-box d-flex flex-wrap align-content-center justify-content-center'>
        <div className='login-form w-100'>
          <div className=' btn-box w-100'>
            <button onClick={() => handleUserType('Customer')} className='btn btn-border text-center w-100 d-block'>Sign up as a Customer</button>
            <button onClick={() => handleUserType('Sugar Daddy')} className='btn btn-border text-center w-100 d-block'>Sign up as a Sugar Daddy</button>
            <button onClick={() => handleUserType('Worker')} className='btn btn-border text-center w-100 d-block'>Sign up as a Worker</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SignupCategory
